import * as yup from "yup"
import type { GroupOfResearches } from "../../types"

export function initialValuesGroupOfResearch(group?: GroupOfResearches | undefined) {
  if (group) {
    return group
  }
  return {
    name: "",
    description: "",
    image: undefined,
    university: "",
    order: 0,
  }
}

export function validationSchemaGroupOfResearch() {
  return yup.object().shape({
    name: yup.string().required("Campo obbligatorio"),
    description: yup.string().required("Campo obbligatorio"),
    image: yup.mixed().required("Campo obbligatorio"),
  })
}
